// ----------------------------------------------------------------------

export function getAllItems({ data, userRole }) {
  if (!data || !Array.isArray(data)) {
    return [];
  }

  const results = [];
  const seen = new Set();

  data.forEach((section) => {
    const subheader = section.subheader || 'Overview';

    function walk(items, parentGroup = null, breadcrumbs = []) {
      if (!items || !Array.isArray(items)) return;

      items.forEach((item) => {
        if (!item || item.disabled) return;

        // Role check if item specifies allowed roles
        if (item.roles && userRole && !item.roles.includes(userRole)) {
          return;
        }

        const currentBreadcrumbs = [...breadcrumbs, item.title];

        if (item.children && item.children.length > 0) {
          // If the parent item itself has a unique navigable path
          const hasChildWithPath = item.children.some((c) => c.path === item.path);
          if (item.path && item.path !== '#' && !hasChildWithPath) {
            const key = `${item.title}|${item.path}|${parentGroup || subheader}`.toLowerCase();
            if (!seen.has(key)) {
              seen.add(key);
              results.push({
                title: item.title,
                path: item.path,
                group: parentGroup || subheader,
                breadcrumb: currentBreadcrumbs.join(' > '),
              });
            }
          }

          walk(item.children, parentGroup || item.title || subheader, currentBreadcrumbs);
        } else if (item.path && item.path !== '#') {
          const itemGroup = parentGroup || subheader;
          const key = `${item.title}|${item.path}|${itemGroup}`.toLowerCase();
          if (!seen.has(key)) {
            seen.add(key);
            results.push({
              title: item.title,
              path: item.path,
              group: itemGroup,
              breadcrumb: currentBreadcrumbs.join(' > '),
            });
          }
        }
      });
    }

    walk(section.items, null, [subheader]);
  });

  return results;
}

// ----------------------------------------------------------------------

export function applyFilter({ inputData, query }) {
  if (!query || !query.trim()) {
    return inputData;
  }

  const queryWords = query.trim().toLowerCase().split(/\s+/).filter(Boolean);

  return inputData.filter((item) => {
    const title = (item.title || '').toLowerCase();
    const path = (item.path || '').toLowerCase();
    const group = (item.group || '').toLowerCase();
    const breadcrumb = (item.breadcrumb || '').toLowerCase();

    return queryWords.every(
      (word) =>
        title.includes(word) ||
        path.includes(word) ||
        group.includes(word) ||
        breadcrumb.includes(word)
    );
  });
}

// ----------------------------------------------------------------------

export function groupedData(array) {
  if (!array || !Array.isArray(array)) {
    return {};
  }

  const group = array.reduce((groups, item) => {
    const groupName = item.group || 'Other';
    groups[groupName] = groups[groupName] || [];
    groups[groupName].push(item);
    return groups;
  }, {});

  return group;
}

// ----------------------------------------------------------------------

export function splitPath(array, key) {
  let stack = array.map((item) => ({
    path: [item.title],
    currItem: item,
  }));

  while (stack.length) {
    const { path, currItem } = stack.pop();

    if (currItem.path === key) {
      return path;
    }

    if (currItem.children?.length) {
      stack = stack.concat(
        currItem.children.map((item) => ({
          path: path.concat(item.title),
          currItem: item,
        }))
      );
    }
  }
  return null;
}

// ----------------------------------------------------------------------

export function handleLoop(array, subheader) {
  return array?.map((list) => ({
    subheader,
    ...list,
    ...(list.children && {
      children: handleLoop(list.children, subheader),
    }),
  }));
}
